import PropTypes from "prop-types";

export const _NavItemRevamp = {
  subNavItem: PropTypes.array,
  isOpened: PropTypes.bool,
};

export const NavItemRevampPropTypes = _NavItemRevamp;
